module.exports = __webpack_public_path__ + "img/restaurant-hookah.7652a2af.svg";